
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  /** Scroll smoothly to a section and close the mobile menu */
  const scrollToSection = (sectionId: string) => {
    try {
      const element = document.getElementById(sectionId);
      if (!element) {
        console.warn(`Element with id "${sectionId}" not found.`);
        return;
      }
      element.scrollIntoView({ behavior: 'smooth' });
    } catch (error) {
      console.error('Scrolling failed:', error);
    } finally {
      // Ensure the mobile menu always closes after a navigation attempt
      setIsMenuOpen(false);
    }
  };

  const LogoContent = () => (
    <button
      onClick={() => scrollToSection('home')}
      className="flex items-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg transition-all hover:opacity-90"
      aria-label="HANBUM Home"
    >
      <img 
        src="https://static.readdy.ai/image/aae90b02d7a9df21e63cac18235c6f1e/a01c0a8d184156c1dfbdaf6512acbfb5.png" 
        alt="HANBUM EST. 1976 Logo" 
        className="h-12 w-auto object-contain"
      />
    </button>
  );

  return (
    <header className="bg-white shadow-sm fixed w-full top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo / Brand */}
          {typeof window !== 'undefined' && window.location.pathname === '/' ? (
            <h1 className="m-0 p-0">
              <LogoContent />
            </h1>
          ) : (
            <LogoContent />
          )}

          {/* Desktop navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {['home', 'products', 'features', 'applications', 'contact'].map(
                (section) => (
                  <button
                    key={section}
                    onClick={() => scrollToSection(section)}
                    className="text-gray-900 hover:text-blue-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {section.charAt(0).toUpperCase() + section.slice(1)}
                  </button>
                )
              )}
            </div>
          </div>

          {/* Mobile menu toggle */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen((prev) => !prev)}
              className="text-gray-700 hover:text-gray-900 cursor-pointer"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              <i
                className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>

        {/* Mobile navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              {['home', 'products', 'features', 'applications'].map((section) => (
                <button
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap"
                >
                  {section.charAt(0).toUpperCase() + section.slice(1)}
                </button>
              ))}
              <button
                onClick={() => scrollToSection('contact')}
                className="block px-3 py-2 text-base font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700 cursor-pointer whitespace-nowrap"
              >
                Contact Us
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
